export default "__VITE_ASSET__CK4RI9Ou__"